import { useRef } from 'react';

import classNames from 'classnames';

import { useVwToPx } from '../../../../hooks/useVwToPx';

import classes from './ChallengeRewardComponent.module.scss';

type ChallengeRewardComponentProps = {
  symbolUrl: string;
  fontSize?: number;
  className?: string;
};

const ChallengeRewardComponent = ({ symbolUrl, className, fontSize: propFontSize }: ChallengeRewardComponentProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const calculatedFontSize = useVwToPx({ ref, vwValue: 19 });
  const fontSize = propFontSize || calculatedFontSize;

  return (
    <div ref={ref} className={classNames(classes.challengeReward, className)} style={{ fontSize }}>
      <img alt="Challenge symbol" className={classes.image} src={symbolUrl} />
    </div>
  );
};

export default ChallengeRewardComponent;
